import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { i18n } from '@zet/localization'

import { handleNavigation, verifyPhoneNumber } from '../functions'

function useVerifyPhoneNumber() {
  const toast = useToast()
  const navigation = useNavigation()
  const queryClient = useQueryClient()

  return useMutation(verifyPhoneNumber, {
    onSuccess(response) {
      const { customerStatus, reason, lockedTill, customerId } = response

      if (lockedTill) {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: reason,
          hideAfter: 3000,
        })
      } else {
        queryClient.invalidateQueries({ queryKey: ['userCustomerCount'] })
        queryClient.invalidateQueries({ queryKey: ['userSummary'] })
        const response = handleNavigation(customerStatus)
        if (response === 'BrandPage') {
          navigation.navigate(response, {
            customerId,
            routeName: 'forCustomerFlow',
          })
        } else {
          navigation.navigate(response, {
            customerId,
          })
        }
      }
    },
    onError(error: string) {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: i18n.t('toastMessages.somethingWentWrong'),
        hideAfter: 3000,
      })
    },
  })
}
export { useVerifyPhoneNumber }
